import { Outlet } from "react-router-dom";
import { useAppSelector } from "../Redux-Toolkit/Hooks";
import FooterCommon from "./Footer";
import Header from "./Header";
import Loader from "./Loader";
import HorizontalSidebar from "./Sidebar/HorizontalSidebar/index";
import VerticalSidebar from "./Sidebar/VerticalSidebar";
import TapTop from "./TapTop/TapTop";
import ThemeCustomizer from "./ThemeCustomizer";

const Layout = () => {
const {layout} = useAppSelector((state)=>state.themeCustomizer)

  return (
    <>
      <Loader />
      <TapTop />
      <div className={`page-wrapper compact-sidebar compact-small ${layout}`} id="pageWrapper">
        <Header />
        <HorizontalSidebar />
        <div className="page-body-wrapper">
          <VerticalSidebar />
          <Outlet />
          <FooterCommon/>
        </div>
        <ThemeCustomizer/>
      </div>
    </>
  );
};

export default Layout;
